<template>
  <div>
    <search :show.sync="showFilterPop" @handlequery="handleFqueryFilter" :type="true" />
    <van-cell style="padding: 16px 10px;">
      <van-tag size="large" type='primary' @click="clickTag(item.dayType)" v-for="(item,index) in timeOptions" :key="index" color="#F4F5F7"
        text-color="#606060" :class="activeId === item.dayType?'tag-click':'tag-before'">{{item.value}}</van-tag>
      <van-icon style="margin-left: 10px" size="20" name="filter-o" @click="handleFilter()" />
    </van-cell>
    <div class="sectionList">
      <van-grid clickable :column-num="1" style="width: 100%">
        <!-- <van-grid-item  >
          <van-tag class="describe" type="success">合同金额</van-tag>
          <div class="th_box">
            <div class="center">
              <span class="Statistics_name">{{contCount.moneySingle.name.replace('合同金额','(元)')}}</span>
              <van-popover v-model="showPopover1" trigger="click" :offset="offset">
                <div class="contTip">合同金额中的单次和框架金额是以合同签约日期来计算</div>
                <template #reference>
                  <van-icon name="question-o" color="#ff976a" size="16" />
                </template>
              </van-popover>
              <div class="percent" v-if="activeId != '2021'">
                <van-icon :name="contCount.moneySingle.float.indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="contCount.moneySingle.float.indexOf('-') == -1?'#07c160':'#ee0a24'" />
                <span class="percentage" :style="contCount.moneySingle.float.indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{contCount.moneySingle.float.replace('-','')}}</span>
              </div>
            </div>
            <div class="S_num" @click="toDetail">{{contCount.moneySingle.count}}</div>
            <div class="center">
              <span class="Statistics_name">{{contCount.moneyFrame.name.replace('合同金额','(元)')}}</span>
              <van-popover v-model="showPopover2" trigger="click" :offset="offset">
                <div class="contTip">合同金额中的单次和框架金额是以合同签约日期来计算</div>
                <template #reference>
                  <van-icon name="question-o" color="#ff976a" size="16" />
                </template>
              </van-popover>

              <div class="percent" v-if="activeId != '2021'">
                <van-icon :name="contCount.moneyFrame.float.indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="contCount.moneyFrame.float.indexOf('-') == -1?'#07c160':'#ee0a24'" />
                <span class="percentage" :style="contCount.moneyFrame.float.indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{contCount.moneyFrame.float.replace('-','')}}</span>
              </div>
            </div>
            <div class="S_num" @click="toDetail">{{contCount.moneyFrame.count}}</div>
          </div>
        </van-grid-item>
        <van-grid-item  @click="toDetail">
          <van-tag class="describe" type="success">回款金额</van-tag>
          <div class="th_box">
            <div class="center" style="margin-top: 10px;">
              <span class="Statistics_name">{{contCount.moneyReturn.name.replace('回款金额','总金额(元)')}}</span>

              <div class="percent" v-if="activeId != '2021'">
                <van-icon :name="contCount.moneyReturn.float.indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="contCount.moneyReturn.float.indexOf('-') == -1?'#07c160':'#ee0a24'" />
                <span class="percentage" :style="contCount.moneyReturn.float.indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{contCount.moneyReturn.float.replace('-','')}}</span>
              </div>
            </div>
            <div class="S_num">{{contCount.moneyReturn.count}}</div>
            <div class="center">
              <span class="Statistics_name">{{contCount.moneyReturnSingle.name.replace('回款单次金额','单次(元)')}}</span>

              <div class="percent" v-if="activeId != '2021'">
                <van-icon :name="contCount.moneyReturnSingle.float.indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="contCount.moneyReturnSingle.float.indexOf('-') == -1?'#07c160':'#ee0a24'" />
                <span class="percentage" :style="contCount.moneyReturnSingle.float.indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{contCount.moneyReturnSingle.float.replace('-','')}}</span>
              </div>
            </div>
            <div class="S_num">{{contCount.moneyReturnSingle.count}}</div>
            <div class="center">
              <span class="Statistics_name">{{contCount.moneyReturnFrame.name.replace('回款框架金额','框架(元)')}}</span>

              <div class="percent" v-if="activeId != '2021'">
                <van-icon :name="contCount.moneyReturnFrame.float.indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="contCount.moneyReturnFrame.float.indexOf('-') == -1?'#07c160':'#ee0a24'" />
                <span class="percentage" :style="contCount.moneyReturnFrame.float.indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{contCount.moneyReturnFrame.float.replace('-','')}}</span>
              </div>
            </div>
            <div class="S_num">{{contCount.moneyReturnFrame.count}}</div>
          </div>
        </van-grid-item> -->
        <van-grid-item>
          <div class="center2">
            <span class="Statistics_num">{{contCount.contSum.count}}</span>
            <span class="Statistics_name">{{contCount.contSum.name}}</span>
          </div>
          <div class="percentage2" v-if="activeId != '2021'">
            <van-icon :name="contCount.contSum.float.indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="contCount.contSum.float.indexOf('-') == -1?'#07c160':'#ee0a24'" />
            <span :style="contCount.contSum.float.indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{contCount.contSum.float.replace('-','')}}</span>
          </div>
        </van-grid-item>
        <!-- <van-grid-item  @click="toDetail">
          <div class="center2">
            <span class="Statistics_num">{{contCount.returnSum.count}}</span>
            <span class="Statistics_name">{{contCount.returnSum.name}}</span>
          </div>
          <div class="percentage2" v-if="activeId != '2021'">
            <van-icon :name="contCount.returnSum.float.indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="contCount.returnSum.float.indexOf('-') == -1?'#07c160':'#ee0a24'" />
            <span :style="contCount.returnSum.float.indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{contCount.returnSum.float.replace('-','')}}</span>
          </div>
        </van-grid-item> -->
      </van-grid>
    </div>
    <div class="radio_group">
      <van-radio-group v-model="frameType" direction="horizontal" icon-size="16px" @change="radioChange">
        <!-- <van-radio name="3" label-position="left">全部</van-radio> -->
        <van-radio name="1" label-position="left">单次</van-radio>
        <van-radio name="2" label-position="left">框架</van-radio>
      </van-radio-group>
    </div>
    <!-- <div class="Statistics_title">合同业绩对比分析</div>
    <div id="main"></div>
    <div class="Statistics_title">销售业务类型业绩统计分析</div>
    <div id="main2">
      <van-empty v-if="isNone" description="暂无数据" />
    </div> -->
    <div class="Statistics_title">合同所属行业分析</div>
    <div id="main3"></div>
    <div class="Statistics_title">合同客户级别分析</div>
    <div id="main4"></div>
    <div class="Statistics_title">合同所属地区分析</div>
    <div id="main5"></div>
    <div class="Statistics_title">媒体版位数据分析</div>
    <div id="main6"></div>
    <div class="Statistics_title">投放链路数据分析</div>
    <div id="main7"></div>
    <!-- <div class="Statistics_title">科技销售业务类型业绩统计分析</div> -->
  </div>
</template>

<script>
import {
  Grid,
  GridItem,
  Popover
  // Image as VanImage
  // Cascader
} from 'vant'
import search from './component/search.vue'
// import { getAllStage } from '@/api/scrm/mycust'
// import { getDicts } from '@/api/system/dict/data'
import statistics from '@/api/tongji/statistics'
// import { CascaderTreeSelect } from '@/api/admi/dept'
import * as echarts from 'echarts'

// import { listStatistical } from '@/api/tongji/index'
export default {
  name: 'TongjiIndex',
  components: {
    search,
    [Grid.name]: Grid,
    // [VanImage.name]: VanImage,
    [GridItem.name]: GridItem,
    // vanCascader: Cascader
    [Popover.name]: Popover
  },
  props: {},
  data() {
    return {
      showFilterPop: false,
      showPopover1: false,
      showPopover2: false,
      offset: [100, 0],
      isNone: false,
      // activeNames: ['1'],
      // icon_title: require('../../assets/images/tj/ghicon.png'),
      activeId: '1',
      frameType: '1',
      queryParams: {
        deptId: null,
        startTime: null,
        endTime: null,
        frameType: 1,
        dayType: '1'
      },
      contCount: {
        contSum: {
          count: '',
          name: '',
          float: ''
        },
        singleSum: {
          count: '',
          name: '',
          float: ''
        },
        frameSum: {
          count: '',
          name: '',
          float: ''
        },
        moneyReturn: {
          count: '',
          name: '',
          float: ''
        },
        moneyReturnSingle: {
          count: '',
          name: '',
          float: ''
        },
        moneyReturnFrame: {
          count: '',
          name: '',
          float: ''
        },
        moneySingle: {
          count: '',
          name: '',
          float: ''
        },
        moneyFrame: {
          count: '',
          name: '',
          float: ''
        },
        returnSum: {
          count: '',
          name: '',
          float: ''
        }
      },
      divisionList: [],
      contractCountList: [],
      paymentCountList: [],
      pieChartList: [],
      saleTypeList: [],
      contIndustryList: [],
      contCustLevlList: [],
      contCustAreaList: [],
      mediaLocationList: [],
      deliveryLinkList: [],
      options: {
        boStageIdOptions: [],
        crmCustLevelOptions: []
      },
      // // 合同类型
      // contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // // 合同状态
      // contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      // // 产品类型列表
      // businessTypeOptions: this.$store.state.dictOptions.businessTypeTree || [],
      timeOptions: [{ dayType: '1', value: '昨天' }, { dayType: '0', value: '今天' }, { dayType: '30', value: '本月' }, { dayType: '180', value: '上半年' }, { dayType: '365', value: '今年' }, { dayType: this.getPreMonth(), value: this.getPreMonth() + '年' }],
      gridList: []
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getStatistics()
  },
  async mounted() {
    this.init()
    await this.getStatisticsByDept()

    await this.getPieChartData()
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = '合同-统计'
    },
    /** 获取上一年 */
    getPreMonth() {
      var date = new Date()
      var year = date.getFullYear()
      return parseInt(year) - 1
    },
    // 获取统计数
    async getStatistics() {
      await statistics.getContractCount(this.queryParams).then(res => {
        if (res.code === 200) {
          this.contCount = res.data
        }
      })
    },
    // 按部门统计合同金额/回款金额
    async getStatisticsByDept() {
      // this.queryParams.deptId = null
      // this.queryParams.isBuss = '1'
      await statistics.getContractCountByDept(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows.slice(0, 10)
          this.contractCountList = []
          this.divisionList = []
          arr.forEach(item => {
            this.contractCountList.push(item.money)
            if (item.deptName) {
              this.divisionList.push(item.deptName.replace('事业部', ''))
            } else {
              this.divisionList.push(item.nickName)
            }
          })
        }
      })
      await statistics.getPaymentCountByDept(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows.slice(0, 10)
          this.paymentCountList = []
          arr.forEach(item => {
            this.paymentCountList.push(item.money)
          })
        }
      })
      // await this.drawChart()
    },
    async getPieChartData() {
      // 销售业务类型业绩分析
    // await getSaleTypeData() {
      // const numArr = []
      this.saleTypeList = []
      // await statistics.getSaleTypeData(this.queryParams).then(res => {
      //   if (res.code === 200) {
      //     const arr = res.rows[0].listData
      //     if (!arr) {
      //       this.saleTypeList = []
      //       this.drawChart2('2')
      //       this.isNone = true
      //     } else {
      //       this.isNone = false
      //       arr.forEach(item => {
      //         this.saleTypeList.push({ name: item.businessTypeName, value: item.money, businessTypeName: item.businessTypeName })
      //       })
      //       this.drawChart2('2')
      //     }
      //   }
      // })
      // }
      // 合同所属行业分析  contIndustryList
      this.contIndustryList = []
      await statistics.getContIndustry(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows[0].listData
          if (!arr) {
            this.contIndustryList = []
            this.drawChart2('3')
          } else {
            arr.forEach(item => {
              this.contIndustryList.push({ name: item.industryName, value: item.count, industryCode: item.industryCode })
            })
            this.drawChart2('3')
          }
        }
      })
      // 合同客户级别分析  contCustLevlList
      this.contCustLevlList = []
      await statistics.getContCustLevl(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows[0].listData
          if (!arr) {
            this.contCustLevlList = []
            this.drawChart2('4')
          } else {
            arr.forEach(item => {
              this.contCustLevlList.push({ name: item.custLevel, value: item.count, custLevelId: item.custLevelId })
            })
            this.drawChart2('4')
          }
        }
      })
      // 合同所属地区分析  contCustAreaList
      this.contCustAreaList = []
      await statistics.getContCustArea(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows[0].listData
          if (!arr) {
            this.contCustAreaList = []
            this.drawChart2('5')
          } else {
            arr.forEach(item => {
              this.contCustAreaList.push({ name: item.province, value: item.count, provinceId: item.provinceId })
            })
            this.drawChart2('5')
          }
        }
      })
      // 媒体版位数据分析  mediaLocationList
      this.mediaLocationList = []
      await statistics.getMediaLocation(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows[0].listData
          if (!arr) {
            this.mediaLocationList = []
            this.drawChart2('6')
          } else {
            arr.forEach(item => {
              this.mediaLocationList.push({ name: item.custLevel, value: item.count, mediaLocationId: item.mediaLocationId })
            })
            this.drawChart2('6')
          }
        }
      })
      // 投放链路数据分析  deliveryLinkList
      this.deliveryLinkList = []
      await statistics.getDeliveryLink(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows[0].listData
          if (!arr) {
            this.deliveryLinkList = []
            this.drawChart2('7')
          } else {
            arr.forEach(item => {
              this.deliveryLinkList.push({ name: item.custLevel, value: item.count, deliveryLinkId: item.deliveryLinkId })
            })
            this.drawChart2('7')
          }
        }
      })
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    // 过滤子组件传递过来的搜索对象
    async handleFqueryFilter(data) {
      this.showFilterPop = false
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      if (this.queryParams.startTime || this.queryParams.endTime) {
        this.activeId = null
      } else {
        this.activeId = '1'
      }
      this.getStatistics()
      await this.getStatisticsByDept()
      await this.getPieChartData()
    },
    async clickTag(id) {
      this.activeId = id
      this.queryParams.dayType = id
      this.queryParams.startTime = null
      this.queryParams.endTime = null
      this.getStatistics()
      await this.getStatisticsByDept()
      await this.getPieChartData()
    },
    async radioChange(val) {
      // console.log(val)
      this.queryParams.frameType = Number(val)
      // this.getStatistics()
      await this.getStatisticsByDept()
      await this.getPieChartData()
    },
    toDetail() {
      this.$router.push({
        path: '/tongji/details',
        query: {
          type: 'contract',
          queryParams: JSON.stringify(this.queryParams)
        }
      })
    },
    drawChart() {
      var chartDom = document.getElementById('main')
      var myChart = echarts.init(chartDom)
      var option
      const that = this
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['合同金额', '回款金额']
        },
        xAxis: [
          {
            type: 'category',
            data: that.divisionList, // ['科技', '创研云', '快人京东', '新媒体', '腾讯广告', '巨量', '创讯', '东巨', '点睛百度'],
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              inside: true
            },
            scale: true,
            axisLabel: {
              margin: 2,
              formatter: function (value, index) {
                if (value >= 10000 && value < 10000000) {
                  value = value / 10000 + '万'
                } else if (value >= 10000000) {
                  value = value / 10000000 + '千万'
                }
                return value
              }
            }
          }
        ],
        grid: {
          left: 42
        },
        series: [
          {
            name: '合同金额',
            type: 'bar',
            barGap: 0,
            emphasis: {
              focus: 'series'
            },
            data: that.contractCountList
          },
          {
            name: '回款金额',
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            data: that.paymentCountList
          }
        ]
      }
      option && myChart.setOption(option)
    },
    drawChart2(val) {
      var chartDom = document.getElementById('main' + val)
      var myChart = echarts.init(chartDom)
      var option
      const that = this
      switch (val) {
        case '2':
          this.pieChartList = this.saleTypeList
          break
        case '3':
          this.pieChartList = this.contIndustryList
          break
        case '4':
          this.pieChartList = this.contCustLevlList
          break
        case '5':
          this.pieChartList = this.contCustAreaList
          break
        case '6':
          this.pieChartList = this.mediaLocationList
          break
        case '7':
          this.pieChartList = this.deliveryLinkList
          break
      }
      // pieChartList
      if (!this.pieChartList || this.pieChartList.length == 0) {
        chartDom.innerHTML = ('-暂无相关数据-')
        chartDom.style.cssText = 'text-align:center; color: #999; border: none;line-height: 300px;font-size: 18px;'
        chartDom.removeAttribute('_echarts_instance_')
        return
      }
      option = {
        // title: {
        //   text: 'Referer of a Website',
        //   subtext: 'Fake Data',
        //   left: 'center'
        // },
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>合同数：{c}份<br/>占比：{d}%' // 鼠标放上去 展示内容
        },
        legend: {
          orient: 'horizontal',
          // left: 'left'
          pageIconSize: 13,
          type: 'scroll'
        },
        series: [
          {
            // name: '金额',
            // top: 30,
            top: val == '3' ? '50' : '',
            type: 'pie',
            radius: '50%',
            // label: {
            //   normal: {
            //     formatter: '{b} [{c}元  {d}%]' //
            //   }
            // },
            data: that.pieChartList,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      option && myChart.setOption(option)

      // var clickTime = null
      // var timeFn = null
      // var onItemName = null
      // // myDate.getMilliseconds();
      // myChart.on('click', function (params) {
      //   var myDate = new Date()
      //   if (clickTime == null) {
      //     // 第一次进来
      //     clickTime = myDate.getMilliseconds()
      //     onItemName = params.name
      //     // 起一个定时器，进行重置
      //     timeFn = setTimeout(function() {
      //       // 要执行的代码
      //       clickTime = null
      //     }, 500)
      //   } else {
      //     clearTimeout(timeFn)
      //     // 第二次进来，
      //     if (Math.abs(myDate.getMilliseconds() - clickTime) < 500 && onItemName == params.name) {
      //       // 是双击操作
      //       console.log(params)
      //       let query = { ...that.queryParams, contractStatus: '7' }
      //       if (params.data.businessTypeName) { query = { ...query, businessTypeName: params.data.businessTypeName } }
      //       if (params.data.industryCode) { query = { ...query, industryCode: params.data.industryCode } }
      //       if (params.data.custLevelId) { query = { ...query, custLevelId: params.data.custLevelId } }
      //       if (params.data.provinceId) { query = { ...query, provinceId: params.data.provinceId } }
      //       if (params.data.mediaLocationId) { query = { ...query, mediaLocationId: params.data.mediaLocationId } }
      //       if (params.data.deliveryLinkId) { query = { ...query, deliveryLinkId: params.data.deliveryLinkId } }
      //       that.$router.push({
      //         path: '/tongji/contractList',
      //         query: {
      //           queryParams: JSON.stringify(query)
      //         }
      //       })
      //     }
      //     clickTime = null
      //   }
      // })
    }
  }
}
</script>

<style scoped lang='less'>
@import url("@/style/index.less");
// *{touch-action: none;}
.van-cell {
  touch-action: none;
}

/deep/.van-cell__value{
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding: 20px 0px;
}
.tag-click{
  border: 0.02667rem solid #1E90FF !important;
  color:#fff !important;
  background-color: #1E90FF !important;
}
.tag-before{
  border: 0.02667rem solid #999999 !important;
  background-color: #fff !important;
}

.sectionList {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  /deep/.van-grid-item__content{
    padding: 20px;
  }
  .describe{
    position: absolute;
    top: 10px;
    left: 10px;
  }
  .th_box{
    padding-top: 10px;
    // padding-bottom: 30px;
    width: 100%;
    .center {
      width: 100%;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // margin-top: 20px;
      .Statistics_num {
        font-size: 30px;
        font-weight: bold;
        color: #0000FF;
        margin-left: 20px;
        margin-right: 20px;
      }
      .Statistics_name{
        margin-top: 20px;
        font-size: 26px;
        color: #87CEFA;
        font-weight: bold;
      }
      .percent{
        // display: flex;
        // justify-content: flex-end;
        width: 50%;
        text-align: right;
      }
      .percentage{
        font-size: 12px !important;
      }
    }
    .S_num {
      width: 100%;
      font-size: 30px;
      font-weight: bold;
      color: #0000FF;
      // text-align: center;
      padding: 10px 0 0 10px;
      // margin-left: 20px;
      // margin-right: 20px;
    }
  }
  .center2{
    height: 160px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .Statistics_num {
      font-size: 30px;
      font-weight: bold;
      color: #0000FF;
    }
    .Statistics_name{
      margin-top: 20px;
      font-size: 26px;
      color: #87CEFA;
      font-weight: bold;
    }
  }
  .percentage2{
    font-size: 10px !important;
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
}
// .rrr{
//   height: 100px;
// }
.Statistics_title{
  margin-top: 20px;
  background-color: #fff;
  padding: 10px 0;
  font-size: 28px;
  color:#87CEFA;
  text-align: center;
}
.radio_group{
  // position: absolute;
  // right: 0;
  // width: 60%;
  background-color: #fff;
  margin-top: 10px;
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
  /deep/.van-radio__label{
    font-size: 22px;
  }
}
.none{
  background-color: #fff;
  margin-top: 10px;
  height: 660px;
}
.contTip{
  padding: 20px;
  width: 600px;
  font-size: 16px;
  color: #333;
}
#main{
  width: 100%;
  height: 700px;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 10px;
}
#main2{
  width: 100%;
  height: 650px;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 10px;
  padding-bottom: 80px;
}
#main3{
  width: 100%;
  height: 700px;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 10px;
}
#main4{
  width: 100%;
  height: 560px;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 10px;
}
#main5{
  width: 100%;
  height: 650px;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 10px;
}
#main6{
  width: 100%;
  height: 600px;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 10px;
}
#main7{
  width: 100%;
  height: 650px;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 10px;
  padding-bottom: 80px;
}
</style>
